/* eslint-disable no-unused-vars */
import React from 'react';
import { Link } from 'react-router-dom';
import useIntersectionObserver from '../hooks/useIntersectionObserver';
import QuoteForm from '../components/forms/QuoteForm';
import { FileText, CheckSquare, Send, Cpu } from 'lucide-react';
import './QuotePage.css';

const MAX_FILES = 5;
const MAX_TOTAL_SIZE_MB = 50;

function QuotePage() {
    const [headerRef, isHeaderVisible] = useIntersectionObserver();
    const [infoRef, isInfoVisible] = useIntersectionObserver();
    // Usunięto ref dla sekcji auto-quote, bo info jest w nagłówku
    const [formSectionRef, isFormSectionVisible] = useIntersectionObserver();

    return (
        <>
            <section ref={headerRef} className={`page-header-section section-bg-white animate-on-scroll ${isHeaderVisible ? 'is-visible' : ''}`}>
                <div className="container text-center">
                    <h1>Uzyskaj Szybką Wycenę Tłumaczenia</h1>
                    <p className="subtitle">Wypełnij poniższy formularz, załącz pliki (do {MAX_FILES} sztuk, łącznie max. {MAX_TOTAL_SIZE_MB}MB), a my przygotujemy dla Ciebie indywidualną, niezobowiązującą ofertę. <br />
                    <span className="auto-quote-notice">Dla plików <strong>DOCX</strong> i <strong>TXT</strong> postaramy się od razu podać orientacyjny koszt!</span>
                    </p>
                </div>
            </section>

            <section ref={infoRef} className={`quote-info-section section-bg-light-gray animate-on-scroll ${isInfoVisible ? 'is-visible' : ''}`}>
                <div className="container">
                    <div className="info-grid">
                        <div className="info-item">
                            <FileText size={40} strokeWidth={1.5} />
                            <h4>Jakie pliki mogę przesłać?</h4>
                            <p>Akceptujemy DOC(X), PDF, TXT, JPG, PNG, ZIP. Dla innych formatów lub większej liczby plików, skontaktuj się z nami.</p>
                        </div>
                        <div className="info-item">
                            <CheckSquare size={40} strokeWidth={1.5} />
                            <h4>Co zawiera wycena?</h4>
                            <p>Otrzymasz szczegółową informację o koszcie (netto/brutto), proponowanym terminie realizacji i ewentualnych dodatkowych opcjach.</p>
                        </div>
                        <div className="info-item">
                             <Send size={40} strokeWidth={1.5} />
                            <h4>Jak szybko otrzymam ofertę?</h4>
                            <p>Staramy się odpowiadać w ciągu kilku godzin roboczych (Pn-Pt, 9-17). Wyceny dla standardowych plików tekstowych są zazwyczaj najszybsze.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Usunięto sekcję auto-quote-info-section */}

            <section ref={formSectionRef} className={`quote-form-section section-bg-white animate-on-scroll ${isFormSectionVisible ? 'is-visible' : ''}`}> {/* Zmieniono tło dla kontrastu */}
                <div className="container">
                     <h2 className="text-center form-wrapper-title">Wypełnij Formularz Wyceny</h2>
                     <div className="quote-form-wrapper">
                         <QuoteForm />
                     </div>
                 </div>
            </section>
        </>
    );
}

export default QuotePage;